import { Store, Building2, Factory, Landmark, ArrowRight, Radar, Briefcase, FileCheck } from "lucide-react";
import { BUSINESS } from "../data/business";

const SERVICES = [
    {
        icon: Store,
        title: "MEI",
        tag: "Microempreendedor Individual",
        description: "Abertura do MEI, notas fiscais, DAS mensal e declaração anual.",
    },
    {
        icon: Building2,
        title: "Simples Nacional",
        tag: "Pequenas empresas",
        description: "Apuração mensal, folha e revisão do anexo para não pagar imposto a mais.",
    },
    {
        icon: Factory,
        title: "Lucro Presumido",
        tag: "Empresas em crescimento",
        description: "Escrituração completa, IRPJ e CSLL, e revisão anual do melhor regime.",
    },
    {
        icon: Landmark,
        title: "Lucro Real",
        tag: "Operações complexas",
        description: "Contabilidade completa, obrigações acessórias e relatórios gerenciais.",
    },
];

export const Services = () => {
    return (
        <section id="servicos" data-testid="services-section" className="relative py-20 lg:py-32 bg-gradient-to-b from-white to-[#F8FAFC] overflow-hidden">
            <div className="absolute -top-24 right-0 w-[420px] h-[420px] rounded-full gold-glow animate-drift-slow pointer-events-none" aria-hidden="true" />
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl reveal-on-scroll">
                    <p className="eyebrow text-xs font-bold uppercase tracking-[0.2em] text-blue-900" data-testid="services-eyebrow">
                        Serviços por regime tributário
                    </p>
                    <h2 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900" data-testid="services-title">
                        Do MEI ao Lucro Real, sua contabilidade em boas mãos
                    </h2>
                    <p className="mt-4 text-base text-slate-600 leading-relaxed" data-testid="services-subtitle">
                        Cada empresa tem um enquadramento ideal — e a gente cuida de tudo, inclusive de onde economizar imposto legalmente.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 reveal-on-scroll" data-testid="services-grid">
                    {SERVICES.map((service, idx) => (
                        <div
                            key={service.title}
                            data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, "-")}`}
                            className="group glass-card rounded-xl p-8 flex flex-col transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
                        >
                            <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-slate-900 text-amber-400 mb-6 transition-transform duration-300 group-hover:scale-110">
                                <service.icon className="w-6 h-6" />
                            </span>
                            <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-blue-900">{service.tag}</p>
                            <h3 className="mt-2 text-xl sm:text-2xl font-medium text-slate-900">{service.title}</h3>
                            <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{service.description}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-16" data-testid="beyond-accounting">
                    <h3 className="text-2xl sm:text-3xl font-semibold tracking-tight text-slate-900" data-testid="beyond-accounting-title">
                        Soluções que vão além da contabilidade
                    </h3>
                    <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div className="group glass-card rounded-xl p-8 sm:p-10 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg" data-testid="service-card-erp">
                            <div className="flex items-center gap-4">
                                <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-slate-900 text-amber-400 transition-transform duration-300 group-hover:scale-110">
                                    <Radar className="w-6 h-6" />
                                </span>
                                <div>
                                    <h4 className="text-xl sm:text-2xl font-medium text-slate-900">ERP de gestão</h4>
                                </div>
                            </div>
                            <p className="mt-4 text-sm text-slate-600 leading-relaxed">
                                Centralize vendas, estoque, financeiro e notas fiscais em uma plataforma, com
                                relatórios em tempo real para acompanhar a saúde do negócio.
                            </p>
                        </div>

                        <div className="group glass-card rounded-xl p-8 sm:p-10 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg" data-testid="service-card-bpo">
                            <div className="flex items-center gap-4">
                                <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-slate-900 text-amber-400 transition-transform duration-300 group-hover:scale-110">
                                    <Briefcase className="w-6 h-6" />
                                </span>
                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-blue-900">Terceirização financeira</p>
                                    <h4 className="text-xl sm:text-2xl font-medium text-slate-900">BPO Financeiro</h4>
                                </div>
                            </div>
                            <p className="mt-4 text-sm text-slate-600 leading-relaxed">
                                Terceirização da gestão financeira: contas a pagar e receber, conciliação bancária,
                                fluxo de caixa, notas e boletos. Você decide com números claros.
                            </p>
                        </div>

                        <div className="group glass-card rounded-xl p-8 sm:p-10 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg" data-testid="service-card-regularizacao">
                            <div className="flex items-center gap-4">
                                <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-slate-900 text-amber-400 transition-transform duration-300 group-hover:scale-110">
                                    <FileCheck className="w-6 h-6" />
                                </span>
                                <div>
                                    <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-blue-900">Volta à conformidade</p>
                                    <h4 className="text-xl sm:text-2xl font-medium text-slate-900">Regularização de Empresas</h4>
                                </div>
                            </div>
                            <p className="mt-4 text-sm text-slate-600 leading-relaxed">
                                CNPJ inapto ou baixado, certidões, parcelamento de débitos e declarações em atraso:
                                a WBS coloca tudo em dia, do início ao fim.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="mt-12 bg-slate-900 rounded-2xl p-8 sm:p-10 flex flex-col lg:flex-row lg:items-center gap-8" data-testid="credit-recovery-card">
                    <div className="flex-1">
                        <p className="text-xs font-bold uppercase tracking-[0.18em] text-amber-400">Serviço em destaque</p>
                        <h3 className="mt-2 text-xl sm:text-2xl font-medium text-white" data-testid="credit-recovery-title">
                            Recuperação de Créditos Tributários
                        </h3>
                        <p className="mt-3 text-sm text-slate-300 leading-relaxed max-w-3xl">
                            Muitas empresas pagam imposto a mais sem saber. A WBS revisa os últimos 5 anos —
                            PIS, COFINS, ICMS e enquadramento — para recuperar esses valores com segurança.
                        </p>
                    </div>
                    <a
                        href={`${BUSINESS.whatsapp}?text=${encodeURIComponent("Olá! Quero uma revisão para recuperar créditos tributários da minha empresa.")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="credit-recovery-cta"
                        className="shrink-0 inline-flex items-center justify-center gap-2 rounded-lg bg-amber-500 hover:bg-amber-600 text-slate-900 font-bold text-sm px-6 py-3.5 transition-transform duration-200 hover:-translate-y-0.5 shadow-sm hover:shadow-md"
                    >
                        Revisar meus impostos
                    </a>
                </div>

                <div className="mt-12 flex" data-testid="services-cta-wrapper">
                    <a
                        href={`${BUSINESS.whatsapp}?text=${encodeURIComponent("Olá! Quero saber qual regime tributário é ideal para minha empresa.")}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="services-cta-link"
                        className="inline-flex items-center gap-2 text-sm font-bold text-blue-900 hover:text-blue-950 transition-colors duration-200 group"
                    >
                        Não sabe qual é o seu regime? A gente descobre junto
                        <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
                    </a>
                </div>
            </div>
        </section>
    );
};
